import translatesComponent  from './translates.component';
import translatesService    from './translates.service';
import translatesFilter     from './translates.filter'

const TranslatesModule = angular
  .module('translates', [])
  .component('translates', translatesComponent)
  .service('$translates', translatesService)
  .filter('translate', translatesFilter);

export default TranslatesModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/translates/translates.js
 **/